import React from 'react';
import { otTimesheetColumnsList } from '../../constants/MockData';
import { AppBar, Dialog, DialogContent, DialogContentText, IconButton, Table, TableBody, TableCell,
  TableHead, TableRow, Toolbar, Tooltip, Typography } from '@material-ui/core';
import { API_URL } from '../../constants/api';
import CancelIcon from '@material-ui/icons/Cancel';
import EditIcon from '@material-ui/icons/Edit';
import { apiBatchRequest, apiPost, downloadReport } from '../../utils/api_service';
import SaveIcon from '@material-ui/icons/Save';
import { ShowToast, toastType } from '../../utils/toast-service';
import { GenerateAbsoluteURL, isGridFormValid, IsSectionVisible } from '../../utils/helper';
import GridTable from '../common/Table/Table';
import { SECTIONS, OT_TIMESHEET_FILE } from '../../constants/appConstants';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';
import _ from 'lodash';
import moment from 'moment';
import { CloudUploadOutlined } from '@material-ui/icons';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';

export default class ConfigureOvertimeTimesheet extends React.PureComponent {
    // Constructor to set initial state
    constructor(props){
      super(props);
      this.inputFile = React.createRef();
      this.state = {
				confirmMessage: null,
      	validationMessage: [],
				isInAddMode: false,
      	isDelete: false,
      	showWarningMessage: false,
      	configuration: [],
				selectedEditRowId: undefined,
      	isEditEnable: true,
				minimumStartDateForNewRecord: null,
      	updateData: {
        	payDate: null,
        	payCycle: null,
        	startDate: null,
        	endDate: null,
        	otFormDueDate: null,
					// status: 1,
        	daysInPayPeriod: 0
      	},
				otTimesheetColumns: _.cloneDeep(otTimesheetColumnsList),
				openUploadFileSuccess: false,
      	invalidRecord: []
			}
    }

		// Method to get data before components are mounted
    componentDidMount() {
      this.getRequiredData();
    }

		// Get data from API for intitial page load
		getRequiredData = () => {
			this._asyncRequest = apiBatchRequest([
				{
					url: API_URL.Employee.GetUltiProOvertimeScheduleDetails,
					key: 'otTimesheetData'
				}
			]).then(({ otTimesheetData }) => {
				this._asyncRequest = null;
        if (otTimesheetData.success !== true) {
          ShowToast(
            'Something went wrong',
            toastType.ERROR,
            5000,
            500,
            'Server error'
          );
        }
				this.setState({
          otTimesheetData: otTimesheetData.data || [],
          configuration: otTimesheetData.config || [],
          reloadTable: !this.state.reloadTable,
					minimumStartDateForNewRecord: this.getMinimumStartDateForNewRecord(otTimesheetData.data || [])
        });
			}).catch(() => {
				this._asyncRequest = null;
			});
		}

		// Get minimum start date for new record creation based on existing records
		getMinimumStartDateForNewRecord = (otTimesheetData) => {
			let latestEndDate = otTimesheetData.reduce(function(r,a) {
				return new Date(r.endDate) > new Date(a.endDate) ? r : a;
			})?.endDate;
			latestEndDate = new Date(latestEndDate);
			latestEndDate.setDate(latestEndDate.getDate() + 1);
			return latestEndDate;
		}

		// Method to validate data while adding new record
		AddNewRecord = () => {
			const {minimumStartDateForNewRecord} = this.state;
			if (this.state.isInAddMode === true) {
				ShowToast('You can add one row at a time!', toastType.WARNING, 5000, 500);
				return false;
			}
			const otTimesheetColumns = _.cloneDeep(otTimesheetColumnsList);			
			otTimesheetColumns.forEach((x) => {
				if(x.dataFormat === 'Date') {
					x.minDate = minimumStartDateForNewRecord;
				}
			})
			otTimesheetColumns.find(x=> x.key === 'startDate').maxDate = minimumStartDateForNewRecord;
			const rowNew = {
				payDate: null,
				payCycle: null,
				startDate: null,
				endDate: null,
				otFormDueDate: null,
				daysInPayPeriod: 0
			};
	
			this.setState({
				isInAddMode: true,
				selectedEditRowId: { key: 'payCycle', value: null },
				reloadTable: !this.state.reloadTable,
				updateData: rowNew,
				otTimesheetColumns
			});
		};

		// Cancel add operation
		cancelAddMode = () => {
			this.setState({
				selectedEditRowId: undefined,
				isInAddMode: false,
				updateData: undefined,
				reloadTable: !this.state.reloadTable
			});
			this.getRequiredData();
		};
		
		// Cancel Edit operation
		cancelEditMode = () => {
			this.setState({
				selectedEditRowId: undefined,
				isInAddMode: false,
				updateData: undefined,
				reloadTable: !this.state.reloadTable
			});
			this.getRequiredData();
		};

		// Edit selected record
		EditRecord = (cellInfo) => {
			const {minimumStartDateForNewRecord} = this.state;
			const otTimesheetColumns = _.cloneDeep(otTimesheetColumnsList);
			
			otTimesheetColumns.forEach((x) => {
				if(x.dataFormat === 'Date') {
					x.minDate = minimumStartDateForNewRecord;
				}
			})
			otTimesheetColumns.find(x=> x.key === 'startDate').maxDate = minimumStartDateForNewRecord;

			this.setState({
				otTimesheetColumns,
				selectedEditRowId: {
					key: 'payCycle',
					value: cellInfo.payCycle
				},
				isInAddMode: false,
				updateData: cellInfo,
				reloadTable: !this.state.reloadTable
			});
		}

		// Delete operation
		onClickHandle(e) {
			if (this.state.isDelete) {
				this.onDeleteHandle(e);
			}
		}

		// Delete record confiramtion
		deleteRecord(cellInfo) {
			this.setState({
				isDelete: true,
				showWarningMessage: true,
				confirmMessage: 'Do you want to delete this record ?',
				updateData: cellInfo
			});
		};

		// Delete record handle event
		onDeleteHandle(e) {
			const newParam = this.state.updateData;
			if (e) {
				// newParam.statusId = 11;
				apiPost({
					url: API_URL.Users.UpdateOvertimeTimesheet,
					postBody: newParam
				}
				).then(({ data: response }) => {
					if (response.success === true) {
						ShowToast('Record deleted successfully.',
							toastType.SUCCESS,
							5000,
							500
						);
	
						this.setState({
							updateData: undefined,
							selectedEditRowId: undefined,
							reloadTable: !this.state.reloadTable,
							isDelete: false,
							showWarningMessage: false
						});
						this.getRequiredData();
						this.forceUpdate();
					} else {
						ShowToast(
							response.message,
							toastType.ERROR,
							5000,
							5000
						);
					}
				});
			} else {
				this.setState({ showWarningMessage: false, confirmationMessage: '' });
			}
		}

		// Check whether Edit icon should visible or not
		isEditIconVisible = (cellInfo) => {
			const {otTimesheetData} = this.state;

			let isVisible = false;
			// if (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_OVERTIME_TIMESHEET, SECTIONS.ADD_EDIT)) {
				let latestEndDate = otTimesheetData.reduce(function(r,a) {
					return new Date(r.endDate) > new Date(a.endDate) ? r : a;
				})?.endDate;

				if(moment(new Date(latestEndDate)).format('DD/MM/YYYY') === moment(new Date(cellInfo.endDate)).format('DD/MM/YYYY')) {
					isVisible = true;
				}				
			// }
			return isVisible;
		}

		// Render Action column
		renderActionColumn = (cellInfo, key, isInAddMode) => {
			return (
				<>
					{this.state.selectedEditRowId !== undefined &&
						cellInfo.payCycle === this.state.selectedEditRowId.value
						? (
							<>
								<Tooltip title="Save Record">
									<IconButton
										aria-label={'refreshData'}
										size="small"
										onClick={() => { }}
									>
										<SaveIcon
											fontSize="small"
											size="small"
											onClick={this.saveUpdatedRecord}
										/>
									</IconButton>
								</Tooltip>
								<Tooltip title="Cancel">
									<IconButton
										aria-label={'refreshData'}
										size="small"
										onClick={this.cancelEditMode}
									>
										<CancelIcon fontSize="small" size="small" />
									</IconButton>
								</Tooltip>
							</>
						)
						: <>
							{this.isEditIconVisible(cellInfo) && (
								<Tooltip title="Edit Record">
									<IconButton
										aria-label={'refreshData'}
										size="small"
										onClick={() => {
											if (this.state.isInAddMode === true || this.state.selectedEditRowId !== undefined) {
												ShowToast('You can add/Edit one row at a time!', toastType.WARNING, 5000, 500);
												return false;
											} else {
												this.EditRecord(cellInfo);
											}
										}}
									>
										<EditIcon fontSize="small" size="small" />
									</IconButton>
								</Tooltip>)}
						</>
					}
				</>
			);
		};

		// Check validations
		isValidForm = () => {
			let IsValid = true;
			const { updateData, otTimesheetColumns } = this.state;
			otTimesheetColumns.forEach((ele) => {
				isGridFormValid(updateData[ele.key], ele, updateData);
				if (ele.isInErrorState === true) {
					IsValid = false;
				}
			});
			this.setState({ otTimesheetColumns }, this.forceUpdate());
			return IsValid;
		};

		// Check duplicate record
		isRecordExistsnWithSameStartDate = () => {
			const { updateData, otTimesheetData } = this.state;
			const timesheetRecord = otTimesheetData.find(x => x.startDate === updateData.startDate &&
				moment(moment(x.startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year() === moment(moment(updateData.startDate).format('DD/MM/YYYY'), 'DD/MM/YYYY').year());
	
			return timesheetRecord !== undefined;
		}
		
		// Save record
		saveUpdatedRecord = () => {
			const { updateData } = this.state;
			if (!this.isValidForm()) { return false; } else {
				if (this.isRecordExistsnWithSameStartDate()) {
					ShowToast(
						'Record with same Start Date : ' + updateData.startDate + ' is already exists', toastType.ERROR, 5000, 500);
					return false;
				} else {
					const newParam = this.state.updateData;
					// newParam.statusId = 1;
					apiPost({
						url: API_URL.Users.UpdateOvertimeTimesheet,
						postBody: newParam
					}
					).then(({ data: response }) => {
						if (response.success === true) {
							ShowToast(
								this.state.isInAddMode
									? 'Record added successfully.'
									: 'Record updated successfully.',
								toastType.SUCCESS,
								5000,
								500
							);
	
							this.setState({
								updateData: undefined,
								selectedEditRowId: undefined,
								reloadTable: !this.state.reloadTable,
								isInAddMode: false
							}, () => {
								this.getRequiredData();
								this.forceUpdate();
							});
						} else {
							ShowToast(
								response.message,
								toastType.ERROR,
								5000,
								5000
							);
						}
					});
				}
			}
		};

		// Handle edit value event
		handleTableEditChange = (value, fieldName) => {
			const { otTimesheetColumns } = this.state;
			const param = this.state.updateData;
			const validationMessage = this.state.validationMessage;
			param[fieldName] = value;
			isGridFormValid(value, otTimesheetColumns.find(x => x.key === fieldName), param);
			const selectedField = otTimesheetColumns.find((x) => x.key === fieldName);
	
			if (selectedField.dependentFieldValidation !== undefined && selectedField.dependentFieldValidation.length > 0) {
				selectedField.dependentFieldValidation.forEach(x => {
					if (param[x] !== undefined && param[x] !== '' && param[x] !== null) {
						const ele = otTimesheetColumns.find((y) => y.key === x);
						isGridFormValid(
							param[x],
							ele,
							param
						);
					}
				});
			}
			if(fieldName === 'startDate' || fieldName === 'endDate') {
				param.payCycle = null;
				param.daysInPayPeriod = 0;
				const startDate = param.startDate;
				const endDate = param.endDate;

				if(startDate !== null && startDate !== undefined && startDate !== '' && endDate !== null && endDate !== undefined && endDate !== ''
					&& new Date(startDate) !== 'Invalid Date' && new Date(endDate) !== 'Invalid Date') {
						const sDate = moment(new Date(startDate));
						const eDate = moment(new Date(endDate));
						param.payCycle = sDate.format('M/D/YY') +'-'+ eDate.format('M/D/YY');
						param.daysInPayPeriod = eDate.diff(sDate, 'days') + 1;
				}
			}			
			this.setState({ updateData: param, validationMessage: (validationMessage || []).filter(x => { return x.key !== fieldName; }) }, () => {
				this.forceUpdate();
			});
		};

		// File change event occues when new file is selected
		onFileChange = (e) => {
			const { files } = e.target;
			if (files && files.length) {
				const filename = files[0].name;
	
				const parts = filename.split('.');
				const fileType = parts[parts.length - 1];
				const excelFileExtension = ['xls', 'xlsx'];
				if (excelFileExtension.includes(fileType.toLowerCase())) {
					this.uploadFile(files);
				} else {
					ShowToast('File format is not supported. Please upload xls or xlsx file.', toastType.ERROR, 5000);
				}
			}
		}

		// Upload file to add new records
		uploadFile = (files) => {
			const f = new FormData();
			f.append('FormFile', files[0]);
			f.append('FileName', files[0].name);
			f.append('OvertimeTimesheet', JSON.stringify(this.state.otTimesheetData));
			apiPost({
				url: API_URL.Users.UploadOvertimeTimesheet,
				postBody: f
			}
			).then(({ data: response }) => {
				if (response.success === true) {
					if (response.data && response.data.length > 0) {
						this.setState({ invalidRecord: response.data, openUploadFileSuccess: true });
					} else {
						ShowToast(
							'Excel file for Overtime Timesheet is uploaded successfully.',
							toastType.SUCCESS,
							5000,
							500
						);
						this.getRequiredData();
					}
				} else {
					ShowToast(
						response.message,
						toastType.ERROR,
						5000,
						5000
					);
				}
			});
		}

		// Download excel file with Invalid records
		downloadFile = (fileMimeType, type, isPrint = false) => {
			const { invalidRecord } = this.state;
			const dataValue = [
				{
					key: 'SSRSData',
					value: invalidRecord.length > 0 ? JSON.stringify(invalidRecord) : null
				},
				{
					key: 'ReportType',
					value: 'Configure Overtime Timesheet'
				}
			];
			const url = GenerateAbsoluteURL(dataValue, [], 'Display%20JSON%20Data%20In%20SSRS', type, false, true);
	
			downloadReport(
				url,
				'Invalid Overtime Timesheet',
				fileMimeType,
				type,
				isPrint
			);
		}

		// Download sample excel file to add new records
		downloadSampleFile = () => {
			fetch(OT_TIMESHEET_FILE).then(response => {
				response.blob().then(blob => {
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = url;
					a.download = 'Overtime Timesheet Template.xlsx';
					a.click();
				});
			});
		}

		// Handle upload document button click event
		onButtonClick = () => {
			this.inputFile.current.click();
		}

		// render the components based on conditions
		render() {
			const { configuration, otTimesheetColumns, openUploadFileSuccess, invalidRecord } = this.state;
			const EditSource = [];

			return (
				<>
					{openUploadFileSuccess && (
						<Dialog open={openUploadFileSuccess} maxWidth="xs" fullWidth={true} >
							<AppBar
								style={{ position: 'relative', backgroundColor: '#064473' }}
							>
								<Toolbar>
									<Typography
										className="app-header-white"
										style={{ marginLeft: '10px', flex: '1', color: '#FFFFF' }}
									>
									Invalid Overtime Timesheet Record(s)
									</Typography>
									<IconButton
										edge="start"
										color="inherit"
										aria-label="close"
										style={{ paddingLeft: '40px' }}
									>
										<IoMdCloseCircleOutline onClick={() => {
											this.setState({ invalidRecord: [], openUploadFileSuccess: false }, () => { this.getRequiredData(); });
										}}
										/>
									</IconButton>
								</Toolbar>
							</AppBar>
							<DialogContent dividers>
								<DialogContentText style={{ color: '#002f6c' }}>
									<label>
										<p>
											Records for Overtime Timesheet are imported successfully, but there are some invalid record(s). Click on below icon to download the same.
										</p>
									</label>
									{invalidRecord?.length > 0 &&
										<div style={{ float: 'right' }}>
											<Tooltip title="Export Excel">
												<IconButton
													size="small"
													onClick={() => this.downloadFile('application/vnd.ms-excel', 'Excel')}>
													<div style={{ fontSize: '1.5rem', color: '#05375E' }}>
														<AssignmentIcon />
													</div>
												</IconButton>
											</Tooltip>
										</div>}
								</DialogContentText>
							</DialogContent>
	
						</Dialog>
					)}
					{this.state.showWarningMessage && (
						<ConfirmDialog
							IsOpen={this.state.showWarningMessage}
							Message={this.state.confirmMessage}
							OnHandelClick={(isValid) => {
								if (isValid) {
									this.onClickHandle(isValid);
								} else {
									this.onClickHandle(isValid);
								}
							}}
							AgreeText="Yes"
							DisAgreeText="No"
						></ConfirmDialog>
					)}
					<Table
						aria-labelledby="tableMenuTitle"
						size={'small'}
						aria-label="configuration table"
					>
						<TableHead>
							<TableRow>
								<TableCell
									key={'configureHeader'}
									className="content-header"
									colSpan={2}
								>
									<div className="content-header d-flex">
										{' '}
										<div
											className="col-xs-11"
											style={{ display: 'inline-block', alignItems: 'center' }}
										>
											Configure Overtime Timesheet
										</div>
									</div>
								</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{ // (IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_OVERTIME_TIMESHEET, SECTIONS.ADD_EDIT)) && 
							(
								<TableRow>
									<TableCell align='right'>
										<Tooltip title="Upload Document">
											<IconButton
												className="action-button"
												variant="contained"
												size="small"
												component="label"
												onChange={(event) => {
													this.onButtonClick();
												}}
											>
												<CloudUploadOutlined size="small"></CloudUploadOutlined>
												<input
													type="file"
													hidden
													ref={this.inputFile}
													onChange={(event) => {
														this.onFileChange(event);
													}}
													onClick={(event) => {
														event.target.value = null;
													}}
													accept=".xlsx, .xls"
												/>
											</IconButton>
										</Tooltip>
										<Tooltip title="Dowload Sample Document">
											<IconButton
												className="action-button"
												variant="contained"
												size="small"
												component="label"
												onClick={(event) => {
													this.downloadSampleFile();
												}}
											>
												<CloudDownloadOutlinedIcon size="small"></CloudDownloadOutlinedIcon>
											</IconButton>
										</Tooltip>
									</TableCell>
								</TableRow>
							)}
							<TableRow>
								<TableCell>
									<GridTable
										validationMessage={this.state.validationMessage || []}
										columns= {otTimesheetColumns} //{UpdateColumnWithConfiguration(otTimesheetColumns, configuration, [] )}
										config={{order: 'desc', orderBy: 'startDate'}}
										data={this.state.otTimesheetData}
										renderActionColumn={this.renderActionColumn}
										selectedEditRowId={this.state.selectedEditRowId}
										isInAddMode={this.state.isInAddMode}
										EditSource={EditSource}
										handleTableEditChange={this.handleTableEditChange}
										updateData={this.state.updateData}
										// AddNewRecord={{
										// 	action: this.AddNewRecord,
										// 	title: 'Add New Overtime Schedule',
										// 	visible: IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.CONFIGURE_OVERTIME_TIMESHEET, SECTIONS.ADD_EDIT)
										// }}
										isInline={true}
										reload={this.state.reloadTable}
									></GridTable>
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
				</>
			);
		}
}